import React from 'react';

export default function QuickActions({ onAction, disabled }) {
  const actions = [
    {
      label: 'Nouvelle annonce',
      icon: '📝',
      message: 'Je veux créer une nouvelle annonce'
    },
    {
      label: 'Rien à déclarer',
      icon: '❌',
      message: 'Je n\'ai rien à déclarer cette semaine'
    }
  ];

  return (
    <div className="mb-6">
      <h3 className="text-sm font-medium text-gray-500 mb-3">Raccourcis rapides</h3>
      <div className="grid grid-cols-2 gap-3">
        {actions.map((action) => (
          <button
            key={action.label}
            onClick={() => onAction(action.message)}
            disabled={disabled}
            className="flex flex-col items-center justify-center p-4 min-h-[100px] bg-white border-2 border-gray-200 rounded-lg hover:border-ia hover:bg-ia hover:bg-opacity-5 transition-colors disabled:opacity-50"
          >
            <span className="text-2xl mb-2">{action.icon}</span>
            <span className="text-sm font-medium text-gray-700">{action.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
